angular.module('aprima-legacy-common').factory('LocalStorageRepository',
    ['storage', '_', 'WebCommonStorageRepository',
        function (storage, _, WebCommonStorageRepository) {
            'use strict';

            function getPatientDashboardsKey(type) {
                var key = 'patientDashboardConfigurations';

                if(angular.isNumber(type)) {
                    type = '' + type + 'cols';
                }

                if(type) {
                    key += '.' + type;
                }
                return key;
            }

            return {

                clearAll: function () {
                    WebCommonStorageRepository.clearAll();
                },

                getIsActiveDirectoryUser: function() {
                    return WebCommonStorageRepository.getIsActiveDirectoryUser();
                },
                
                setIsActiveDirectoryUser: function(value) {
                    WebCommonStorageRepository.setIsActiveDirectoryUser(value);
                },

                getClientID: function () {
                    return WebCommonStorageRepository.getClientId();
                },

                setClientID: function (value) {
                    WebCommonStorageRepository.setClientId(value);
                },

                getNotificationTimeout: function () {
                    return storage.get('notificationTimeout');
                },

                setNotificationTimeout: function (value) {
                    storage.set('notificationTimeout', value);
                },

                setIdentityHint: function (value) {
                    storage.set('identityHint', value);
                },
                
                getIdentityHint: function () {
                    return storage.get('identityHint');
                },

                getClientURL: function () {
                    return WebCommonStorageRepository.getClientUrl();
                },

                setClientURL: function (value) {
                    WebCommonStorageRepository.setClientUrl(value);
                },

                getGatewayUrl: function () {
                    return storage.get('gatewayUrl');
                },

                setGatewayUrl: function (value) {
                    storage.set('gatewayUrl', value);
                },

                setJsonWebToken: function (jwt) {
                    WebCommonStorageRepository.setJsonWebToken(jwt);
                },
                getJsonWebToken: function () {
                    return WebCommonStorageRepository.getJsonWebToken();
                },

                removeJsonWebToken: function () {
                    WebCommonStorageRepository.removeJsonWebToken();
                },

                setUserName: function (username) {
                    WebCommonStorageRepository.setUserName(username);
                },
                getUserName: function () {
                    return WebCommonStorageRepository.getUserName();
                },

                setBirthDate: function (birthDate) {
                    storage.set('birthDate', birthDate);
                },

                getBirthDate: function () {
                    return storage.get('birthDate');
                },

                setAccessCode: function (statementId) {
                    storage.set('accessCode', statementId);
                },

                getAccessCode: function () {
                    return storage.get('accessCode');
                },

                setUserFullName: function (name) {
                    WebCommonStorageRepository.setUserFullName(name);
                },

                getUserFullName: function () {
                    return WebCommonStorageRepository.getUserFullName();
                },

                removeUserName: function () {
                    storage.remove('userName');
                },

                setUserID: function (userid) {
                    WebCommonStorageRepository.setUserId(userid);
                },

                getUserID: function () {
                    return WebCommonStorageRepository.getUserId();
                },

                getIsPatient: function () {
                    return storage.get('isPatient');
                },

                setIsPatient: function (isPatient) {
                    storage.set('isPatient', isPatient);
                },

                getSupportedFeatures: function () {
                    return storage.get('apiSupportedFeatures');
                },
                removeUserID: function () {
                    WebCommonStorageRepository.removeUserId();
                },

                setLang: function (lang) {
                    storage.set('lang', lang);
                },

                getLang: function () {
                    var lang = storage.get('lang');
                    return lang;
                },

                setDefaultSuperbillSubmissionMethod: function (methodId) {
                    storage.set('superbillMethod', methodId);
                },

                getDefaultSuperbillSubmissionMethod: function() {
                    return storage.get('superbillMethod');
                },

                setKey: function (key, value, keyType) {
                    storage.set(key, value);

                    if(keyType){
                        var activeKeys = storage.get(keyType + 'keys');
                        var keyDictionary;

                        if(activeKeys){
                            keyDictionary = activeKeys.split(',');
                        }
                        else{
                            keyDictionary = [];
                        }

                        if(!_.includes(keyDictionary, key)){
                            keyDictionary.push(key);
                            storage.set(keyType + 'keys', keyDictionary.join(','));
                        }
                    }
                },

                getKey: function (key, keyType) {
                    var k = storage.get(key);

                    // This can be removed after 1 release with it in there.  It just needs to be there to build up the initial list.
                    if(keyType){
                        var activeKeys = storage.get(keyType + 'keys');
                        var keyDictionary;

                        if(activeKeys){
                            keyDictionary = activeKeys.split(',');
                        }
                        else{
                            keyDictionary = [];
                        }

                        if(!_.includes(keyDictionary, key)){
                            keyDictionary.push(key);
                            storage.set(keyType + 'keys', keyDictionary.join(','));
                        }
                    }

                    return k;
                },

                removeKey: function (key) {
                    storage.remove(key);
                },
                setPatientDashboardWidgets: function (widget) {
                    storage.set('patientDashboardWidgets', widget);
                },

                getPatientDashboardWidgets: function () {
                    var pdw = storage.get('patientDashboardWidgets');
                    return pdw;
                },
                setPatientDashboardConfigurations: function (newList, type) {
                    var list = this.getPatientDashboardConfigurations(type) || [];
                    var hasV1Tiles = _.some(list, function (val) {
                        return !_.isUndefined(val.WidgetDescriptors);
                    });

                    if(!_.isEmpty(list) && !hasV1Tiles) {
                        _.forEach(newList, function (val) {
                            val.Tiles = _.map(val.Tiles, function (tile) {
                                var savedConfig = _(list).find({Id: val.Id});
                                if(savedConfig) {
                                    var savedTile = _(savedConfig.Tiles).find({Id: tile.Id});
                                    if(savedTile) {
                                        return _.defaults(tile, savedTile);
                                    }
                                }
                                return tile;
                            });
                        });
                    }

                    storage.set(getPatientDashboardsKey(type), newList);
                },

                removePatientDashboardWidgets: function () {
                    storage.remove('patientDashboardWidgets');
                },

                overwritePatientDashboardConfigurations: function (newList, type) {
                    storage.set(getPatientDashboardsKey(type), newList);
                },

                getPatientDashboardConfigurations: function (type) {
                    return storage.get(getPatientDashboardsKey(type));
                },

                removePatientDashboardConfigurations: function (type) {
                    storage.remove(getPatientDashboardsKey(type));
                },

                getDashboardTileSettings: function () {
                    return WebCommonStorageRepository.getDashboardTileSettings();
                },
                setDashboardTileSettings: function (settings) {
                    WebCommonStorageRepository.setDashboardTileSettings(settings);
                },
                setDefaultDashboardTileSettings: function (settings) {
                    WebCommonStorageRepository.setDefaultDashboardTileSettings(settings);
                },

                getAppointmentsListSettings: function () {
                    return WebCommonStorageRepository.getAppointmentsListSettings();
                },
                setAppointmentsListSettings: function (settings) {
                    WebCommonStorageRepository.setAppointmentsListSettings(settings);
                },
                setDefaultAppointmentsListSettings: function (settings) {
                    WebCommonStorageRepository.setDefaultAppointmentsListSettings(settings);
                },

                getMessagesListSettings: function () {
                    return WebCommonStorageRepository.getMessagesListSettings();
                },
                setMessagesListSettings: function (settings) {
                    WebCommonStorageRepository.setMessagesListSettings(settings);
                },
                setDefaultMessagesListSettings: function (settings) {
                    WebCommonStorageRepository.setDefaultMessagesListSettings(settings);
                },

                getAppointmentsBadgeSettings: function () {
                    return WebCommonStorageRepository.getAppointmentsBadgeSettings();
                },
                setAppointmentsBadgeSettings: function (settings) {
                    WebCommonStorageRepository.setAppointmentsBadgeSettings(settings);
                },
                setDefaultAppointmentsBadgeSettings: function (settings) {
                    WebCommonStorageRepository.setDefaultAppointmentsBadgeSettings(settings);
                },

                getDefaultServiceSiteId: function() {
                    return storage.get('serviceSiteId');
                },

                setDefaultServiceSiteId: function(serviceSiteId) {
                    storage.set('serviceSiteId', serviceSiteId);
                },

                getDeviceId: function () {
                    return WebCommonStorageRepository.getDeviceId();
                },

                setDeviceId: function (deviceId) {
                    WebCommonStorageRepository.setDeviceId(deviceId);
                },

                getPhoneMessageGeneralNoteTypeId: function () {
                    return WebCommonStorageRepository.getPhoneMessageGeneralNoteTypeId();
                },
                setPhoneMessageGeneralNoteTypeId: function (id) {
                    WebCommonStorageRepository.setPhoneMessageGeneralNoteTypeId(id);
                },

                getTaskMessageGeneralNoteTypeId: function () {
                    return WebCommonStorageRepository.getTaskMessageGeneralNoteTypeId();
                },
                setTaskMessageGeneralNoteTypeId: function (id) {
                    WebCommonStorageRepository.setTaskMessageGeneralNoteTypeId(id);
                },

                getPharmacyGeneralNoteTypeId: function () {
                    return WebCommonStorageRepository.getPharmacyGeneralNoteTypeId();
                },
                setPharmacyGeneralNoteTypeId: function (id) {
                    WebCommonStorageRepository.setPharmacyGeneralNoteTypeId(id);
                },

                getPortalMessageGeneralNoteTypeId : function () {
                    return WebCommonStorageRepository.getPortalMessageGeneralNoteTypeId();
                },
                setPortalMessageGeneralNoteTypeId : function (id) {
                    WebCommonStorageRepository.setPortalMessageGeneralNoteTypeId(id);
                },

                getRxRefillMessageGeneralNoteTypeId : function () {
                    return WebCommonStorageRepository.getRxRefillMessageGeneralNoteTypeId();
                },
                setRxRefillMessageGeneralNoteTypeId : function (id) {
                    WebCommonStorageRepository.setRxRefillMessageGeneralNoteTypeId(id);
                },

                getPharmacyRefillMessageGeneralNoteTypeId : function () {
                    return WebCommonStorageRepository.getPharmacyRefillMessageGeneralNoteTypeId();
                },
                setPharmacyRefillMessageGeneralNoteTypeId : function (id) {
                    WebCommonStorageRepository.setPharmacyRefillMessageGeneralNoteTypeId(id);
                },

                getPatientVitalsDefaultSettingId: function () {
                    return WebCommonStorageRepository.getPatientVitalsDefaultSettingId();
                },
                setPatientVitalsDefaultSettingId: function (id) {
                    WebCommonStorageRepository.setPatientVitalsDefaultSettingId(id);
                },

                getMedicationOverrideGeneralNoteTypeId : function () {
                    return WebCommonStorageRepository.getMedicationOverrideGeneralNoteTypeId();
                },
                setMedicationOverrideGeneralNoteTypeId : function (id) {
                    WebCommonStorageRepository.setMedicationOverrideGeneralNoteTypeId(id);
                },

                getCurrentUserLicenses: function getCurrentUserLicenses() {
                    return storage.get('settings.currentUserLicenses');
                },
                setCurrentUserLicenses: function setCurrentUserLicenses(licenses) {
                    storage.set('settings.currentUserLicenses', licenses);
                },

                getIsERxEnabled: function () {
                    return storage.get('settings.erxenabled');
                },
                setIsERxEnabled: function (enabled) {
                    storage.set('settings.erxenabled', !!enabled);
                },

                getAllowImperialUnits: function () {
                    return storage.get('settings.allowImperialUnitsInPrescription');
                },
                setAllowImperialUnits: function (allowed) {
                    storage.set('settings.allowImperialUnitsInPrescription', !!allowed);
                },

                getApplicationVersion: function(){
                    return storage.get('applicationVersion');
                },
                setApplicationVersion: function(version){
                    storage.set('applicationVersion', version);
                },
                getUserPermissions: function(){
                    return WebCommonStorageRepository.getUserPermissions();
                },
                setUserPermissions: function(permissions){
                    WebCommonStorageRepository.setUserPermissions(permissions);
                },
                getAskedUserForTouchID: function() {
                    return storage.get('askedUserForTouchID');
                },
                setAskedUserForTouchID: function(prompt) {
                    storage.set('askedUserForTouchID', prompt);
                },
                getUserEnabledTouchID: function() {
                    return storage.get('userEnabledTouchID');
                },
                setUserEnabledTouchID: function(enabled) {
                    storage.set('userEnabledTouchID', enabled);
                },
                getOncePerLoginChartConsent: function() {
                    return storage.get('OncePerLoginChartConsent');
                },
                setOncePerLoginChartConsent: function(enabled) {
                    storage.set('OncePerLoginChartConsent', enabled);
                },

                clearKeysOfType: function(keyType){
                    var activeKeys = storage.get(keyType + 'keys');
                    if(activeKeys){
                        var keyDictionary = activeKeys.split(',');

                        _.forEach(keyDictionary, function(key){
                            storage.remove(key);
                        });
                    }

                    storage.remove(keyType + 'keys');
                },

                clearSessionStorage: function(){
                    clearKeysOfType('list');
                    clearKeysOfType('metadata');
                },

                clearOldVersionCache: function(){
                    storage.remove('messagetypessupportedforcreate');
                },

                setIsCacheClient: function(value){
                    storage.set('settings.iscacheclient', value);
                },

                setIsCacheUser: function(value){
                    storage.set('settings.iscacheuser', value);
                }
            };
        }]);
